import { render } from "./videos.vue?vue&type=template&id=5d712d26&scoped=true"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"

import "./videos.vue?vue&type=style&index=0&id=5d712d26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d712d26"]])

export default __exports__